export function updateTerrain(terrain, planet) {
  return {
    type: 'UPDATE_TERRAIN',
    payload: terrain,
    planet,
  };
}

export function updateTerrainBlock(terrainBlock) {
  return {
    type: 'UPDATE_TERRAIN_BLOCK',
    payload: terrainBlock,
  };
}
